module.exports = __webpack_public_path__ + "img/移动2.578309c1.svg";